import React from 'react'
import Stars from 'Components/stars'
import FontSize10 from 'Components/font-size-10'

const yellow_star_little = require('static/yellow-star-little.png')
const black_star_little = require('static/black-star-little.png')

export interface IProps {
  year?: string
  carName?: string
  score?: number
  scoreText?: string
}

const CarModel: React.FC<IProps> = ({
  year,
  carName,
  score = 0,
  scoreText,
}) => {
  return (year && carName) || score || scoreText ? (
    <React.Fragment>
      <div className="tw-flex tw-mt-16 tw-items-center tw-h-22 tw-leading-22">
        {year && carName ? (
          <h3 className="tw-font-medium tw-flex-none tw-mr-12">{`${year}款${carName}`}</h3>
        ) : null}
        {score ? (
          <React.Fragment>
            <span className="score tw-flex-none tw-pl-34 tw-mr-4 tw-text-12 tw-flex tw-items-center">
              {(score / 100 || 0).toFixed(2)}
              <FontSize10
                width={10}
                height={14}
                className="tw-opacity-80 tw-mb-2"
              >
                分
              </FontSize10>
            </span>
            <Stars
              marginRight={1}
              starIcon={yellow_star_little}
              starVacantIcon={black_star_little}
              score={score / 100}
              maxScore={5}
              starWidth={8}
              starHeight={8}
            />
          </React.Fragment>
        ) : null}
        {scoreText ? (
          <span className="tw-ml-8 tw-text-12">&ldquo;{scoreText}&rdquo;</span>
        ) : null}
      </div>
      <style jsx>
        {`
          .score {
            background: url('${require('static/dcar-score-icon.png')}') left
              center/30px auto no-repeat;
          }
        `}
      </style>
    </React.Fragment>
  ) : null
}

export default CarModel
